<template>
  <v-container>
    <v-card class="pa-5" color="gray10" flat>
      <div class="d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon size="28" class="me-3" clr="var(--v-gray1-base)">
            $documentLegalUsers
          </v-icon>
          <span class="font-Bold-14">
            {{ $t("corporateAccount.companyInformation.companyInformation") }}
          </span>
        </div>
        <div class="button d-flex align-center">
          <v-icon size="20" class="me-1" clr="var(--v-success-base)"
            >$checkMarkCircle</v-icon
          >
          <span
            class="font-Medium-12 text-no-wrap d-none d-xl-block d-lg-block d-md-block d-sm-block gray1--text"
          >
            {{ data.status.locale }}
          </span>
        </div>
      </div>

      <v-row class="py-1 mt-2">
        <v-col xl="2">
          <div class="font-Regular-14 gray2--text">
            {{ $t("corporateAccount.companyInformation.companyName") }}
          </div>
        </v-col>
        <v-col xl="10" class="d-flex align-center justify-space-between">
          <div class="font-Medium-14 gray1--text">
            {{ data.name }}
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="py-1">
        <v-col xl="2">
          <div class="font-Regular-14 gray2--text">
            {{ $t("corporateAccount.companyInformation.nationalID") }}
          </div>
        </v-col>
        <v-col xl="10">
          <div class="font-Medium-14 gray1--text">
            {{ data.economic_code }}
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="py-1">
        <v-col xl="2">
          <div class="font-Regular-14 gray2--text">
            {{ $t("corporateAccount.companyInformation.establishmentDate") }}
          </div>
        </v-col>
        <v-col xl="10">
          <div class="font-Medium-14 gray1--text">
            {{ data.registration_date | formatDate }}
          </div>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="py-1">
        <v-col xl="2">
          <div class="font-Regular-14 gray2--text">
            {{ $t("corporateAccount.companyInformation.userType") }}
          </div>
        </v-col>
        <v-col xl="10">
          <div class="font-Medium-14 gray1--text">
            {{
              $cookies.get("CA_ID") &&
                $t("corporateAccount.companyInformation.legal")
            }}
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import legalService from "@/services/modules/legalService";

export default {
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.getDetails();
  },
  methods: {
    getDetails() {
      legalService
        .accountDetailsWithMember(this.$cookies.get("CA_ID"))
        .then(response => {
          this.data = response.data.data;
        });
    }
  }
};
</script>
